import {InjectionToken} from '@angular/core';

export interface AuthConfig {
    apiKey: string;
    authDomain: string;
    storageBucket: string;
    messagingSenderId: string;
    projectId: string;
    appId: string;
    vapidKey: string;
}

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AUTH_CONFIG');
